"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoThumbnail;

var _immutable = _interopRequireDefault(require("immutable"));

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var _Constants = require("../Constants");

var defaultState = _immutable.default.Map({
  updateThumbnailRequestStatus: _Constants.RequestStatus.UNINITIALIZED,
  generateAndUpdateThumbnailRequestStatus: _Constants.RequestStatus.UNINITIALIZED
});

function VideoThumbnail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type;

  switch (type) {
    case ActionTypes.VIDEO_THUMBNAIL_UPDATE_ATTEMPTED:
      return state.set('updateThumbnailRequestStatus', _Constants.RequestStatus.PENDING);

    case ActionTypes.VIDEO_THUMBNAIL_UPDATE_FAILED:
      return state.set('updateThumbnailRequestStatus', _Constants.RequestStatus.FAILED);

    case ActionTypes.VIDEO_THUMBNAIL_UPDATE_SUCCEEDED:
      return state.set('updateThumbnailRequestStatus', _Constants.RequestStatus.SUCCEEDED);

    case ActionTypes.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_ATTEMPTED:
      return state.set('generateAndUpdateThumbnailRequestStatus', _Constants.RequestStatus.PENDING);

    case ActionTypes.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_FAILED:
      return state.set('generateAndUpdateThumbnailRequestStatus', _Constants.RequestStatus.FAILED);

    case ActionTypes.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED:
      return state.set('generateAndUpdateThumbnailRequestStatus', _Constants.RequestStatus.SUCCEEDED);

    default:
      return state;
  }
}

module.exports = exports.default;